import * as React from 'react';

// Please replace, if IE11-support isn't required any longer.
//import {useForm, FormContext} from 'react-hook-form';
import {useForm, FormContext} from 'react-hook-form/dist/react-hook-form.ie11';

type FormProps = {
	onSubmit: (data: any, event: React.SyntheticEvent) => void;
	defaultValues?: object;
	className?: string;
}
const Form: React.FunctionComponent<FormProps> = ({onSubmit, defaultValues = {}, children, className}) => {
	const form = React.useRef(null);
	const formApi = useForm({
		defaultValues,
		submitFocusError: false
	});
	const {isValid, submitCount} = formApi.formState;

	React.useEffect(() => {
		if (submitCount > 0 && !isValid) {
			const $form = form.current! as HTMLFormElement;
			const $firstError = $form.querySelector('[data-invalid="1"]');

			if ($firstError) {
				const top = $firstError.getBoundingClientRect().top + window.pageYOffset - 30;

				window.scrollTo({top, behavior: 'smooth'});
			}
		}
	}, [submitCount]);

	return (
		<FormContext {...formApi}>
			<form
				onSubmit={formApi.handleSubmit(onSubmit)}
				className={className}
				ref={form}
			>
				{children}
			</form>
		</FormContext>
	)
}

export default Form;
